import React, {useContext, useEffect, useState, useMemo, useCallback} from "react";
import {configContext} from "./ConfigProvider";
import {LayoutSplashScreen} from "../_metronic/layout";
import AutomaticLogout from '../components/auth/AutomaticLogout';
import useInterval from '../hooks/useInterval';
import {authentication} from '../api/user';

export const authContext = React.createContext();

const AuthProvider = (props) => {
  const config = useContext(configContext);
  // false means the auth status is unknown
  const [authUser, setAuthUser] = useState(false);

  const idleTimer = useMemo(() => {
    return (config.client || {}).idle_timer || {};
  }, [config]);

  const authenticate = useCallback((authResult) => {
    const now = (new Date()).getTime();
    localStorage.setItem('sign_in_time', `${now}`);
    localStorage.setItem('access_token', authResult.data.accessToken);
    setAuthUser({
      ...authResult.data.sys_user || {},
      ...authResult.data.wb_user || {}
    })
  }, [setAuthUser])

  const signOut = useCallback(() => {
    setAuthUser(null)
    localStorage.removeItem('sign_in_time');
    localStorage.removeItem('access_token');
  }, [setAuthUser])

  const getToken = useCallback((refresh) => {
    const token = localStorage.getItem('access_token');
    return Promise.resolve(token)
  }, [])

  const getSignInTime = useCallback(() => {
    const timeNumberString = localStorage.getItem('sign_in_time');
    const timeParsed = parseInt(timeNumberString);
    if (isNaN(timeParsed)) {
      if(!authUser) return undefined;
      const now = (new Date()).getTime();
      localStorage.setItem('sign_in_time', `${now}`);
      return now
    } else {
      return timeParsed
    }
  }, [authUser])

  const reAuthenticate  = useCallback(() => {
    getToken().then((accessToken) => {
      if (accessToken) {
        return authentication({accessToken})
          .then((authResult) => {
            setAuthUser((prev) => {
              const authUid = authResult.data.sys_user ? authResult.data.sys_user.uid : authResult.data.wb_user ? authResult.data.wb_user.uid : null;
              if (!prev || prev.uid !== authUid) {
                return {
                  ...authResult.data.sys_user || {},
                  ...authResult.data.wb_user || {}
                };
              }
              return prev;
            })
          })
      } else {
        setAuthUser(null);
      }
    }).catch(() => {
      setAuthUser(null);
    })
  },[getToken, setAuthUser])
  useEffect(() => {
    reAuthenticate()
  }, [])
  useInterval(() => {
    reAuthenticate()
  }, 60 * 1000)

  if (authUser === false) return <LayoutSplashScreen/>
  return (
    <authContext.Provider
      value={{ authUser, getToken, signOut, getSignInTime, authenticate}}
    >
      <AutomaticLogout
        idleTimeout={parseInt(idleTimer.idle)}
        promptTimeout={parseInt(idleTimer.prompt)}
        signInTimeout={parseInt(idleTimer.signIn)}
      />
      {props.children}
    </authContext.Provider>
  );
};

export default AuthProvider;
